import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>General provisions</Summary>
        <Details>
          <p>
            1.1. These terms and conditions of use (hereinafter the{" "}
            <strong>Terms and Conditions</strong>) of the self-service regulate
            the use of the self-service environment (hereinafter the{" "}
            <strong>Self-service</strong>) of PlusPlus by natural persons who
            have or have had a financial obligation to PlusPlus (PlusPlus Baltic
            OÜ, registry code 12273105, address Tartu mnt 83, 10115 Tallinn or
            AS PlusPlus Capital, registry code 11919806, address Tartu mnt 83,
            10115 Tallinn, hereinafter <strong>PlusPlus</strong>) and who have
            been entered in the systems of PlusPlus connected with Self-service
            (hereinafter the <strong>Customers</strong>).
            <br />
            1.2. The Self-service allows a Customer to obtain an overview of the
            data related to the claims of PlusPlus and the obligations of the
            Customer as well as to perform actions made available by PlusPlus
            via the computer network.&nbsp;
            <br />
            1.3. By using the Self-service, the Customer confirms that he/she
            has acquainted himself/herself with the Terms and Conditions, has
            agreed to the Terms and Conditions and undertakes to comply with
            them. The Terms and Conditions shall be binding for the Customer.
            <br />
            1.4. In addition to the Terms and Conditions, the Customer shall
            upon entering the Self-service and performing actions therein be
            obligated to comply with any additional instructions given by
            PlusPlus in the Self-service.&nbsp;
            <br />
            1.5. PlusPlus retains the right to unilaterally alter the functions
            of the Self-service as well as the volume and procedure of use of
            the services and actions enabled via the Self-service without
            notifying the Customer thereof.
            <br />
            1.6. PlusPlus shall have the right to carry out maintenance in the
            Self-service and PlusPlus shall give notice of planned maintenance
            or service disruptions that are known in advance via the
            Self-service or the webpage of PlusPlus (www.plusplus.ee).
            <br />
            1.7. PlusPlus shall have the right to amend the Terms and Conditions
            at any time, notifying the Customers thereof via the Self-service or
            its webpage (www.plusplus.ee). Any amendments to the Terms and
            Conditions shall enter into force as of the date of the publication
            thereof in the Self-service or the webpage, unless stipulated
            otherwise in the amended Terms and Conditions.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Entry into and security of Self-service</Summary>
        <Details>
          <p>
            2.1. In order to use the Self-service, the Customer has to log in to
            the Self-service, using the prescribed means.
            <br />
            2.2. The Customer can initially log in to the Self-service with an
            ID card, Mobile-ID or Smart-ID.
            <br />
            2.3. After the initial login, a Customer can create his/her own user
            account, and in such a case the Customer shall subsequently be able
            to log in to the Self-service also via the user account by entering
            the user name and password upon login.
            <br />
            2.4. The Self-service password chosen by the Customer is
            confidential information that the Customer shall undertake to keep
            secret and not disclose to third persons.&nbsp;
            <br />
            2.5. The Customer shall ensure the existence of the software and
            hardware necessary and suitable for the use of the Self-service. The
            Customer shall be obligated to ensure that his/her security and
            other solutions (including anti-virus programmes) conform to modern
            standards and do not block the usage of the Self-service.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Rights, obligations and liability of Customers</Summary>
        <Details>
          <p>
            3.1. The Customer shall be obligated to:
            <br />
            3.1.1. safe-keep the Self-service password, the ID card PIN and PUK
            codes, and the Mobile-ID PIN and PUK codes, Smart-ID PIN codes and
            prevent these from coming into the possession of third persons and
            not give his/her ID card to third persons;
            <br />
            3.1.2. keep secure and not disclose to third persons any other
            confidential information related to the Customer or PlusPlus, and
            prevent the access of third persons to the said information;
            <br />
            3.1.3. immediately notify PlusPlus if Self-service password, the ID
            card PIN or PUK codes, the Mobile-ID PIN or PUK codes, Smart-ID PIN
            codes have become known to third persons, as well as of any other
            circumstances that may result in misuse of the Self-service in the
            name of the Customer;
            <br />
            3.1.4. ensure that third persons do not have access to the e-mail
            address(es) that the Customer has disclosed to PlusPlus and to which
            the Customer’s user account is linked; &nbsp;
            <br />
            3.1.5. keep their details displayed in the Self-service up to date
            and correct and make the relevant changes in the Customer’s details
            in the Self-service within 10 (ten) days of any changes in the
            Customer’s contact details.
            <br />
            3.2. The Customer shall be liable for all the obligations assumed
            and actions performed via the Self-service, as well as for the
            correctness of the data entered by the Customer.
            <br />
            3.3. The Customer is aware and confirms that the Customer’s
            statements of intent and documents submitted and actions performed
            via the Self-service are legally binding, have legal force
            equivalent to documents signed in handwriting and the Customer is
            liable for all the Customer’s obligations that have arisen. PlusPlus
            shall have the right to request the digital signing of the documents
            submitted via the Self-service. &nbsp;&nbsp;
            <br />
            3.4. The Customer can discontinue using the Self-service at any
            time, notifying PlusPlus of the relevant wish using the contact
            details provided on the webpage of PlusPlus. After that, PlusPlus
            shall block the Customer’s access to the Self-service.
            <br />
            3.5. If the Customer wishes to submit questions or observations with
            regard to the Self-service, he/she can do that by contacting the
            customer service via the webpage of PlusPlus or sending a notice to
            the e-mail address info@plusplus.ee.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Rights and obligations of PlusPlus</Summary>
        <Details>
          <p>
            4.1. PlusPlus shall have the right to prevent or restrict access to
            the Self-service or refuse to accept the actions performed via the
            Self-service, if:
            <br />
            4.1.1. the Customer’s Self-service password is entered incorrectly
            at least three times; or
            <br />
            4.1.2. PlusPlus has learnt of circumstances that give grounds to
            conclude that the means necessary for performing the Customer’s
            actions via the Self-service have become known to a third person; or
            <br />
            4.1.3. PlusPlus has detected activities aimed against the
            Self-service from the computer used for entering the Self-service or
            performing procedures in the Self-service; or
            <br />
            4.1.4. PlusPlus has detected the use of the Self-service in a manner
            that violates the applicable legal act; or
            <br />
            4.1.5. the Customer has violated the Terms and Conditions; or
            <br />
            4.1.6. the Customer has violated any obligations arising from an
            agreement or the contract concluded with PlusPlus and fails to
            fulfil such obligations within an additional term granted by
            PlusPlus.&nbsp;
            <br />
            4.2. PlusPlus shall have the right to temporarily or permanently
            discontinue the provision of the Self-service service, giving the
            Customer notice thereof.
            <br />
            4.3. If PlusPlus has any doubts as to the authenticity or
            correctness of the documents or data submitted by the Customer via
            the Self-service, PlusPlus shall be entitled to demand the
            submission of additional documents or data from the Customer and the
            Customer shall be obligated to submit these.
            <br />
            4.4. PlusPlus shall not be liable for any damage caused to the
            Customer if a third person enters the Self-service portal and
            performs actions in the name of the Customer using the Customer’s
            details, passwords and/or PIN codes.
            <br />
            4.5. PlusPlus shall not be liable for any faults and disruptions in
            the work of the Self-service that have been caused by the Customer’s
            equipment, the Customer’s e-mail configuration or overload or the
            non-conformity of the Customer’s computer with the IT requirements
            necessary for using the Self-service.
            <br />
            4.6. PlusPlus shall not be liable for any damage caused to the
            Customer due to the impossibility of using the Self-service in
            connection with any technical faults or disruptions.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Intellectual property protection</Summary>
        <Details>
          <p>
            5.1. The Self-service environment is the property of PlusPlus, and
            the copyrights to the content of the environment (including
            graphics, text, logos, icons, images) and software belong to
            PlusPlus and are protected by the legal acts that regulate the
            protection of intellectual property.
            <br />
            5.2. The forms, content and data in the Self-service environment may
            not be copied, reproduced, forwarded, sold or used in any other
            manner in a non-purposeful way (including for commercial purposes).
            The copying, distribution, forwarding, publication or alteration of
            the Self-service is not permitted and shall result in liability in
            accordance with the Copyright Act and other legal acts that regulate
            the protection of intellectual property.
          </p>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Processing personal data</Summary>
        <Details>
          <p>
            6.1. PlusPlus, in connection with the Self-service, shall process
            the Customer’s personal data that already exist in the systems of
            PlusPlus as well as personal data that the Customer has entered in
            the Self-service (including for identifying the Customer upon login
            to the Self-service) or which PlusPlus has learnt in another manner
            during the course of communicating with the Customer. PlusPlus
            processes the personal data of the Customer in accordance with the
            Privacy Notice that can be accessed here:
            https://plusplus.ee/en/privacy-notice/
          </p>
          <p>
            <br />
            These Terms and Conditions enter into force from 1&nbsp;&nbsp;August
            2018.
          </p>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
